var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-container" }, [
    _c(
      "div",
      { ref: "messageContainer", staticClass: "chat-messages" },
      _vm._l(_vm.messages, function(message, index) {
        return _c(
          "div",
          { key: index, staticClass: "message", class: message.type },
          [
            _c("div", { staticClass: "message-content" }, [
              _c("div", { staticClass: "message-header" }, [
                _c("span", { staticClass: "user-name" }, [
                  _vm._v(_vm._s(message.userName))
                ]),
                _c(
                  "span",
                  { staticClass: "message-actions" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("CargoMsg.Cargo_Copy"),
                          placement: "top"
                        }
                      },
                      [
                        _c("el-button", {
                          staticClass: "message-action-btn",
                          attrs: {
                            type: "text",
                            icon: "el-icon-document-copy",
                            size: "mini"
                          },
                          on: {
                            click: function($event) {
                              return _vm.copyMessage(message.text)
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t("CargoMsg.Cargo_Delete"),
                          placement: "top"
                        }
                      },
                      [
                        _c("el-button", {
                          staticClass: "message-action-btn",
                          attrs: {
                            type: "text",
                            icon: "el-icon-delete",
                            size: "mini"
                          },
                          on: {
                            click: function($event) {
                              return _vm.deleteMessage(index)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              !message.isHtml
                ? _c("div", {
                    staticClass: "message-text",
                    domProps: { textContent: _vm._s(message.text) }
                  })
                : _c("div", {
                    staticClass: "message-text",
                    domProps: { innerHTML: _vm._s(message.text) }
                  })
            ])
          ]
        )
      }),
      0
    ),
    _vm.isLoading
      ? _c("div", { staticClass: "loading-indicator" }, [
          _c("div", { staticClass: "loading-circle" }),
          _c("span", { staticClass: "loading-text" }, [
            _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ChatThinking")))
          ])
        ])
      : _vm._e(),
    _vm.voiceRecognition.isRecording
      ? _c(
          "div",
          { staticClass: "loading-indicator voice-recording-indicator" },
          [
            _c("i", { staticClass: "el-icon-microphone voice-icon" }),
            _c("span", { staticClass: "loading-text" }, [
              _vm._v(
                _vm._s(
                  _vm.$t("CargoMsg.Cargo_VoiceRecording", [
                    _vm.voiceRecognition.remainingTime
                  ])
                )
              )
            ]),
            _vm._m(0)
          ]
        )
      : _vm._e(),
    _c("div", { staticClass: "chat-input" }, [
      _c(
        "div",
        { staticClass: "input-container" },
        [
          _c("el-input", {
            staticClass: "message-input",
            class: { "voice-recording": _vm.voiceRecognition.isRecording },
            attrs: {
              type: "textarea",
              rows: 5,
              placeholder: _vm.voiceRecognition.isRecording
                ? _vm.$t("CargoMsg.Cargo_VoiceRecordingInput")
                : _vm.$t("CargoMsg.Cargo_ChatInputPlaceholder"),
              disabled: _vm.isLoading || _vm.isRevision
            },
            on: { input: _vm.handleManualInput },
            nativeOn: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.handleEnter($event)
              }
            },
            model: {
              value: _vm.inputMessage,
              callback: function($$v) {
                _vm.inputMessage = $$v
              },
              expression: "inputMessage"
            }
          }),
          _c(
            "div",
            { staticClass: "button-group" },
            [
              _c(
                "el-button",
                {
                  staticClass: "send-btn",
                  attrs: {
                    type: "primary",
                    icon: "el-icon-s-promotion",
                    loading: _vm.isLoading,
                    disabled: _vm.voiceButtonDisabled
                  },
                  on: { click: _vm.sendMessage }
                },
                [_vm._v(" " + _vm._s(_vm.$t("CargoMsg.Cargo_Send")) + " ")]
              ),
              _c(
                "el-button",
                {
                  staticClass: "voice-btn",
                  class: { recording: _vm.voiceRecognition.isRecording },
                  attrs: {
                    type: _vm.voiceRecognition.isRecording
                      ? "danger"
                      : "default",
                    icon: _vm.voiceButtonIcon,
                    loading: _vm.voiceRecognition.isProcessing,
                    disabled: _vm.voiceButtonDisabled
                  },
                  on: { click: _vm.handlePlaceholderAction }
                },
                [_vm._v(" " + _vm._s(_vm.voiceButtonText) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "voice-wave" }, [
      _c("span", { staticClass: "wave-bar" }),
      _c("span", { staticClass: "wave-bar" }),
      _c("span", { staticClass: "wave-bar" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }